"use client";

import { cn } from "@/lib/utils";
import React from "react";
import { ButtonStyleType, SpacingType } from "@/types";
import { sectionVariants } from "@/types";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import parse from "html-react-parser";
import { SectionWrapper } from "../components/SectionWraper";

interface Feature5Props { 
  darkMode?: boolean; 
  variant?: sectionVariants;
  spacing?: SpacingType;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  themeChangeOnScroll?: boolean;
  title?: string;
  content?: string;
  hasButton?: boolean;
  buttonText?: string;
  buttonLink?: string;
  buttonStyle?: ButtonStyleType;
  microCopy?: string;
  features?: {
    content?: string;
  }[];
  attributes?: React.HTMLProps<HTMLElement>;
}

const Feature5 = ({
  darkMode = false,
  variant = "A",
  spacing,
  usedInPageNav = false,
  pageNavTitle = "Feature 5",
  themeChangeOnScroll = false,
  title,
  content,
  hasButton,
  buttonText,
  buttonLink,
  buttonStyle,
  microCopy,
  features,
  attributes,
}: Feature5Props) => {
  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="feature5"
      attributes={attributes}
    >
      <div className="container" data-aos="fade-up">
        <div className="flex flex-col lg:items-center gap-14 lg:gap-20 lg:flex-row">
          <div className="flex flex-col gap-10 lg:w-1/2">
            {title && (
              <h2 className="text-center sm:text-left">
                {parse(title)}
              </h2>
            )}
            {content && (
              <div className="paragraph-lg text-center sm:text-left">
                {parse(content)}
              </div>
            )}
            {hasButton && (
              <div>
                <Button size="lg" variant={buttonStyle} asChild className="w-full sm:w-auto">
                  <Link href={buttonLink ?? ""}>
                    {buttonText}
                  </Link>
                </Button>
                {microCopy && (
                  <div className="paragraph-sm text-muted-foreground mt-3 text-center sm:text-left">
                    {microCopy}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="lg:w-1/2">
            {features && (
            <ul className="paragraph-lg">
                {features.map((item, index) => (
                  <li 
                    className={
                      cn(
                        // "flex items-start", 
                        "check-list-lg text-muted-foreground py-6",
                        index !== features.length - 1 && "border-b"
                      )}  
                    key={index}
                  >
                    {parse(item.content ?? "")}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export { Feature5 };



